// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as StatusRouteImport } from './routes/status'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as HealthRouteImport } from './routes/health'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as LendersIndexRouteImport } from './routes/lenders.index'
import { Route as LendersSlugRouteImport } from './routes/lenders.$slug'
import { Route as AuthenticatedWalletRouteImport } from './routes/_authenticated/wallet'
import { Route as AuthenticatedMarketplaceRouteImport } from './routes/_authenticated/marketplace'
import { Route as AuthenticatedKycRouteImport } from './routes/_authenticated/kyc'
import { Route as AuthenticatedInvestRouteImport } from './routes/_authenticated/invest'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard'
import { Route as AuthenticatedBorrowRouteImport } from './routes/_authenticated/borrow'
import { Route as AuthenticatedAnalyzerRouteImport } from './routes/_authenticated/analyzer'
import { Route as AuthenticatedAdminMessagesRouteImport } from './routes/_authenticated/admin-messages'
import { Route as AuthenticatedAdminDomainRouteImport } from './routes/_authenticated/admin-domain'
import { Route as AuthenticatedAdminAuditRouteImport } from './routes/_authenticated/admin-audit'
import { Route as AuthenticatedAdminAlertSettingsRouteImport } from './routes/_authenticated/admin-alert-settings'
import { Route as AuthenticatedAdminRouteImport } from './routes/_authenticated/admin'
import { Route as AuthenticatedCoachIndexRouteImport } from './routes/_authenticated/coach.index'
import { Route as AuthenticatedCoachThreadIdRouteImport } from './routes/_authenticated/coach.$threadId'
import { Route as AuthenticatedCheckoutReturnRouteImport } from './routes/_authenticated/checkout.return'

const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const StatusRoute = StatusRouteImport.update({
            id: '/status',path: '/status',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const PricingRoute = PricingRouteImport.update({
            id: '/pricing',path: '/pricing',getParentRoute: () => rootRouteImport
          })
const HealthRoute = HealthRouteImport.update({
            id: '/health',path: '/health',getParentRoute: () => rootRouteImport
          })
const FaqRoute = FaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const LendersIndexRoute = LendersIndexRouteImport.update({
            id: '/lenders/',path: '/lenders/',getParentRoute: () => rootRouteImport
          })
const LendersSlugRoute = LendersSlugRouteImport.update({
            id: '/lenders/$slug',path: '/lenders/$slug',getParentRoute: () => rootRouteImport
          })
const AuthenticatedWalletRoute = AuthenticatedWalletRouteImport.update({
            id: '/wallet',path: '/wallet',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedMarketplaceRoute = AuthenticatedMarketplaceRouteImport.update({
            id: '/marketplace',path: '/marketplace',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedKycRoute = AuthenticatedKycRouteImport.update({
            id: '/kyc',path: '/kyc',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedInvestRoute = AuthenticatedInvestRouteImport.update({
            id: '/invest',path: '/invest',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedBorrowRoute = AuthenticatedBorrowRouteImport.update({
            id: '/borrow',path: '/borrow',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAnalyzerRoute = AuthenticatedAnalyzerRouteImport.update({
            id: '/analyzer',path: '/analyzer',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminMessagesRoute = AuthenticatedAdminMessagesRouteImport.update({
            id: '/admin-messages',path: '/admin-messages',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminDomainRoute = AuthenticatedAdminDomainRouteImport.update({
            id: '/admin-domain',path: '/admin-domain',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminAuditRoute = AuthenticatedAdminAuditRouteImport.update({
            id: '/admin-audit',path: '/admin-audit',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminAlertSettingsRoute = AuthenticatedAdminAlertSettingsRouteImport.update({
            id: '/admin-alert-settings',path: '/admin-alert-settings',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminRoute = AuthenticatedAdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedCoachIndexRoute = AuthenticatedCoachIndexRouteImport.update({
            id: '/coach/',path: '/coach/',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedCoachThreadIdRoute = AuthenticatedCoachThreadIdRouteImport.update({
            id: '/coach/$threadId',path: '/coach/$threadId',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedCheckoutReturnRoute = AuthenticatedCheckoutReturnRouteImport.update({
            id: '/checkout/return',path: '/checkout/return',getParentRoute: () => AuthenticatedRouteRoute
          })





const AuthenticatedRouteRouteChildren = {
  AuthenticatedAdminRoute: AuthenticatedAdminRoute,AuthenticatedAdminAlertSettingsRoute: AuthenticatedAdminAlertSettingsRoute,AuthenticatedAdminAuditRoute: AuthenticatedAdminAuditRoute,AuthenticatedAdminDomainRoute: AuthenticatedAdminDomainRoute,AuthenticatedAdminMessagesRoute: AuthenticatedAdminMessagesRoute,AuthenticatedAnalyzerRoute: AuthenticatedAnalyzerRoute,AuthenticatedBorrowRoute: AuthenticatedBorrowRoute,AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,AuthenticatedInvestRoute: AuthenticatedInvestRoute,AuthenticatedKycRoute: AuthenticatedKycRoute,AuthenticatedMarketplaceRoute: AuthenticatedMarketplaceRoute,AuthenticatedWalletRoute: AuthenticatedWalletRoute,AuthenticatedCheckoutReturnRoute: AuthenticatedCheckoutReturnRoute,AuthenticatedCoachThreadIdRoute: AuthenticatedCoachThreadIdRoute,AuthenticatedCoachIndexRoute: AuthenticatedCoachIndexRoute
}

const AuthenticatedRouteRouteWithChildren = AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,AuthRoute: AuthRoute,ContactRoute: ContactRoute,FaqRoute: FaqRoute,HealthRoute: HealthRoute,PricingRoute: PricingRoute,PrivacyRoute: PrivacyRoute,ResetPasswordRoute: ResetPasswordRoute,StatusRoute: StatusRoute,TermsRoute: TermsRoute,LendersSlugRoute: LendersSlugRoute,LendersIndexRoute: LendersIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)